import { useEffect } from 'react';
import { useOfferteDetailDrawerStore } from '../../stores/offerte-detail-drawer-store';
import { OfferteDetailView } from './OfferteDetailView';

/**
 * Overlay-drawer voor offerte-detail. Globaal gemount in AppLayout, zodat elke
 * page `useOfferteDetailDrawerStore.open(leadId)` kan aanroepen — zelfde
 * patroon als OrderDetailDrawerPanel.
 *
 * Stacking: zelfde tier als de order-drawer (z-[55]/z-[60]). Mount in
 * AppLayout vóór OrderDetailDrawerPanel, zodat een order-drawer die vanuit
 * deze drawer opent bovenop paint (latere DOM-order wint bij gelijke z-index).
 */
export function OfferteDetailDrawerPanel() {
  const openOfferteId = useOfferteDetailDrawerStore((s) => s.openOfferteId);
  const close = useOfferteDetailDrawerStore((s) => s.close);

  useEffect(() => {
    if (!openOfferteId) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      const t = e.target as HTMLElement | null;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT')) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      close();
    };
    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, [openOfferteId, close]);

  if (!openOfferteId) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-slate-900/30 z-[55]"
        onClick={close}
        aria-hidden
      />
      <aside
        className="fixed top-0 right-0 h-full w-full max-w-2xl bg-white shadow-2xl z-[60] flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-label="Offerte detail"
      >
        <OfferteDetailView
          key={openOfferteId}
          offerteId={openOfferteId}
          variant="drawer"
          onClose={close}
        />
      </aside>
    </>
  );
}
